import { createFileRoute, redirect } from '@tanstack/react-router';
import { Skeleton } from '@/components/ui/skeleton';
import { AppShell } from '@/components/layout/AppShell';
import { DraftsList } from '@/components/DraftsList';
import { useDrafts } from '@/hooks/use-drafts';
import { getToken } from '@/lib/auth';

export const Route = createFileRoute('/websites/$websiteId/drafts')({
  beforeLoad: () => {
    if (!getToken()) throw redirect({ to: '/connect' });
  },
  component: DraftsPage,
});

function DraftsPage() {
  const { websiteId } = Route.useParams();
  const d = useDrafts(websiteId);

  return (
    <AppShell websiteId={websiteId} active="drafts">
      <div className="mx-auto max-w-4xl p-8">
        <h1 className="mb-6 text-2xl font-semibold">Entwürfe</h1>
        {d.isLoading && <Skeleton className="h-40 w-full" />}
        <DraftsList
          drafts={d.data ?? []}
          isSuccess={d.isSuccess}
          isError={d.isError}
        />
      </div>
    </AppShell>
  );
}
